export const ANIMATE_CLASS =
  'card-hover opacity-0 translate-y-4 transition-all duration-700';

export function AnimatedCard({ children, className = '', as: Tag = 'div', ...props }) {
  return (
    <Tag
      data-animate
      className={`${ANIMATE_CLASS} ${className}`.trim()}
      {...props}
    >
      {children}
    </Tag>
  );
}
